import { Injectable } from '@angular/core';
import { isUndefined } from 'lodash';
import { Observable, Subject } from 'rxjs';
import { BannerCanvasTypesEnum } from '../features-data/features-data.data';
import { IGrowthDialogData } from '../features/components/growth-dialog/growth-dialog.interface';
import { ILoadingDialogData } from './components/loading-dialog/loading-dialog.component';
import { DIALOG_TYPE as loadingDialog } from './components/loading-dialog/loading-dialog.constant';
import { DialogActionsEnum, IDialogTrigger } from './dialog.data';

@Injectable()
export class DialogService {
  private _dialogTriggers: Subject<IDialogTrigger> = new Subject<IDialogTrigger>();

  dialogTriggers$: Observable<IDialogTrigger> = this._dialogTriggers.asObservable();

  constructor() {}

  openDialog({
    type,
    data = {},
    emitEvent = true,
  }: {
    type: string;
    data?: any;
    emitEvent?: boolean;
  }) {
    this._dialogTriggers.next({
      type,
      action: DialogActionsEnum.open,
      emitEvent,
      data,
    });
  }

  closeDialog({
    type,
    data = {},
    emitEvent = true,
  }: {
    type: string;
    data?: any;
    emitEvent?: boolean;
  }) {
    this._dialogTriggers.next({
      type,
      action: DialogActionsEnum.close,
      emitEvent,
      data,
    });
  }

  refreshDialog({
    type,
    emitEvent = true,
  }: {
    type: string;
    emitEvent?: boolean;
  }) {
    this._dialogTriggers.next({
      type,
      action: DialogActionsEnum.refresh,
      emitEvent,
    });
  }

  openLoadingDialog(customString?: string) {
    const dialogData: ILoadingDialogData = {
      label: customString,
    };

    this.openDialog({
      type: loadingDialog,
      data: dialogData,
    });
  }

  closeLoadingDialog() {
    this.closeDialog({
      type: loadingDialog,
    });
  }

  openGrowthDialog(
    bannerCanvasType: BannerCanvasTypesEnum,
    featureName: string,
    primaryActionCallback?: Function,
    secondaryActionCallback?: Function
  ) {
    const dialogData: IGrowthDialogData = {
      primaryActionCallback,
      secondaryActionCallback,
    };

    this.openDialog({
      type: isUndefined(bannerCanvasType)
        ? featureName
        : `${bannerCanvasType}_${featureName}`,
      data: dialogData,
    });
  }

  closeGrowthDialog(
    bannerCanvasType: BannerCanvasTypesEnum,
    featureName: string
  ) {
    if (!bannerCanvasType) {
      return this.closeDialog({ type: featureName });
    }

    this.closeDialog({ type: `${bannerCanvasType}_${featureName}` });
  }

  openConfirmDialog(dialogId: string, data?: any) {
    this.openDialog({ type: `confirm-${dialogId}`, data });
  }

  closeConfirmDialog(dialogId: string) {
    this.closeDialog({ type: `confirm-${dialogId}` });
  }
}
